/* BrameCam - RYTHME VERTICAL UNIQUE
 *
 * On mesure le dernier pixel PEINT de chaque bloc et le premier du
 * suivant, puis on corrige la marge pour que cet ecart reel soit
 * identique partout. Le blanc interne des sections est absorbe.
 *
 * ---------------------------------------------------------------
 * CORRECTION 2026-08-15 : DEFILEMENT PARASITE SUR MOBILE
 *
 * La premiere version remettait toutes les marges a zero avant de
 * remesurer. La page se rétractait d'un coup de plusieurs milliers
 * de pixels, le navigateur ramenait la position de defilement dans
 * les limites, puis la page reprenait sa hauteur : vu de l'ecran,
 * ca donne un scroll qui part tout seul. Sur mobile, chaque image
 * en chargement differe relançait ce cycle pendant le defilement.
 *
 * Deux changements :
 *  1. On ne remet plus rien a zero. On lit la marge en place et on
 *     l'ajuste du delta necessaire. La page ne se rétracte jamais.
 *  2. On ne touche a la position de defilement que si un bloc situe
 *     AU-DESSUS du bas de l'ecran a bouge. Quand seules des images
 *     sous la ligne de flottaison se chargent, rien de visible ne
 *     bouge : on ne touche pas au scroll, donc pas d'inertie cassee
 *     sur iOS.
 * ---------------------------------------------------------------
 *
 * Garde-fous de mesure :
 *  - ROGNAGE : un accordeon replie contient du texte reel mais
 *    invisible car rogne par un overflow. On descend l'arbre en
 *    tenant a jour la zone visible et chaque element y est ramene.
 *  - OPACITE IGNOREE : le theme fait apparaitre les blocs en fondu au
 *    defilement. Un bloc encore sous la ligne de flottaison est a
 *    opacity 0 mais occupe deja sa place. On mesure la mise en page,
 *    pas l'opacite : seuls display:none et visibility:hidden comptent.
 *  - BANDEAUX COLLES : deux bandeaux pleine largeur qui se touchent
 *    deja restent colles (bandeau sous le hero, bande de reassurance).
 *  - FICHE PRODUIT : la bande de reassurance qui suit la presentation
 *    produit est rapprochee. On exige une URL /products/, sinon la
 *    regle se declencherait aussi sur l'accueil ou le bloc best-seller
 *    contient un bouton d'ajout au panier.
 *
 * En-tete et pied de page ne sont pas concernes : on ne regarde que
 * les enfants directs de #MainContent.
 */
(function () {
  'use strict';

  var GAP_DESKTOP = 88;
  var GAP_MOBILE = 52;
  var PRODUCT_TRUST_GAP_DESKTOP = 24;
  var PRODUCT_TRUST_GAP_MOBILE = 18;
  var GLUE_THRESHOLD = 6;
  var MAX_PULL_UP = -200;
  var MIN_STEP = 1;
  var PAGE_BG = 'rgb(255, 255, 255)';
  var running = false;
  var lastWidth = 0;
  var observer = null;
  var settleTimer = null;

  function onProductPage() {
    return window.location.pathname.indexOf('/products/') !== -1;
  }

  function isBlank(color) {
    return !color || color === 'transparent' || color === 'rgba(0, 0, 0, 0)' || color === PAGE_BG;
  }

  function paints(el, cs) {
    if (!isBlank(cs.backgroundColor)) return true;
    if (cs.backgroundImage && cs.backgroundImage !== 'none') return true;
    if (/^(IMG|SVG|VIDEO|CANVAS|IFRAME|PICTURE)$/.test(el.tagName)) return true;
    if (parseFloat(cs.borderTopWidth) > 0 || parseFloat(cs.borderBottomWidth) > 0) return true;
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType === 3 && node.textContent.trim()) return true;
    }
    return false;
  }

  function descend(el, clip, acc) {
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return;

    var rect = el.getBoundingClientRect();
    var top = rect.top > clip.top ? rect.top : clip.top;
    var bottom = rect.bottom < clip.bottom ? rect.bottom : clip.bottom;
    var left = rect.left > clip.left ? rect.left : clip.left;
    var right = rect.right < clip.right ? rect.right : clip.right;

    if (bottom > top && right > left && paints(el, cs)) {
      if (top < acc.top) acc.top = top;
      if (bottom > acc.bottom) acc.bottom = bottom;
      if (left < acc.left) acc.left = left;
      if (right > acc.right) acc.right = right;
    }

    var childClip = clip;
    if (cs.overflow !== 'visible' || cs.overflowY !== 'visible' || cs.overflowX !== 'visible') {
      childClip = {
        top: clip.top > rect.top ? clip.top : rect.top,
        bottom: clip.bottom < rect.bottom ? clip.bottom : rect.bottom,
        left: clip.left > rect.left ? clip.left : rect.left,
        right: clip.right < rect.right ? clip.right : rect.right
      };
    }

    var kids = el.children;
    for (var i = 0; i < kids.length; i++) descend(kids[i], childClip, acc);
  }

  function inkBounds(root) {
    var box = root.getBoundingClientRect();
    var acc = { top: Infinity, bottom: -Infinity, left: Infinity, right: -Infinity };
    descend(root, { top: -1e6, bottom: 1e6, left: -1e6, right: 1e6 }, acc);

    if (!isFinite(acc.top)) return { top: Infinity, bottom: -Infinity, wide: false };

    if (acc.top < box.top) acc.top = box.top;
    if (acc.bottom > box.bottom) acc.bottom = box.bottom;
    if (acc.bottom < acc.top) acc.bottom = acc.top;

    return {
      top: acc.top,
      bottom: acc.bottom,
      wide: (acc.right - acc.left) >= (window.innerWidth - 4)
    };
  }

  function collect(main) {
    var sections = [];
    var children = main.children;
    for (var i = 0; i < children.length; i++) {
      var node = children[i];
      if (node.classList && node.classList.contains('shopify-section') && node.offsetHeight > 0) {
        sections.push(node);
      }
    }
    return sections;
  }

  function currentMargin(section) {
    var v = parseFloat(section.style.marginTop);
    return isNaN(v) ? 0 : v;
  }

  function apply() {
    if (running) return;
    var main = document.getElementById('MainContent');
    if (!main) return;

    running = true;
    lastWidth = window.innerWidth;

    var narrow = window.innerWidth < 750;
    var target = narrow ? GAP_MOBILE : GAP_DESKTOP;
    var trustGap = narrow ? PRODUCT_TRUST_GAP_MOBILE : PRODUCT_TRUST_GAP_DESKTOP;
    var productPage = onProductPage();
    var sections = collect(main);

    /* Reperes avant modification : on retiendra le premier bloc encore
       visible pour pouvoir remettre l'ecran exactement ou il etait. */
    var viewportBottom = window.innerHeight;
    var anchor = null;
    var anchorTop = 0;
    for (var a = 0; a < sections.length; a++) {
      var ar = sections[a].getBoundingClientRect();
      if (ar.bottom > 0) { anchor = sections[a]; anchorTop = ar.top; break; }
    }

    var movedAboveFold = false;
    var previous = null;
    var previousIsProduct = false;

    sections.forEach(function (section) {
      var ink = inkBounds(section);
      if (!isFinite(ink.top)) return;

      if (previous !== null) {
        var gap = ink.top - previous.bottom;
        var wanted = previousIsProduct ? trustGap : target;
        var margin = currentMargin(section);
        var next;

        if (gap <= GLUE_THRESHOLD && previous.wide && ink.wide) {
          next = margin - gap;
        } else {
          next = margin + (wanted - gap);
          if (next < MAX_PULL_UP) next = MAX_PULL_UP;
        }

        next = Math.round(next);

        /* Ajustement incrementiel : on ne remet jamais la marge a zero,
           donc la page ne se rétracte pas et le defilement ne saute
           pas. */
        if (Math.abs(next - margin) >= MIN_STEP) {
          if (section.getBoundingClientRect().top < viewportBottom) movedAboveFold = true;
          section.style.marginTop = next + 'px';
          ink = inkBounds(section);
        }
      }

      previous = ink;
      previousIsProduct = productPage && !!section.querySelector('form[action*="/cart/add"]');
    });

    /* On ne recale l'ecran que si quelque chose de visible a bouge.
       Quand seules des images sous la ligne de flottaison se chargent,
       on ne touche pas au scroll : l'inertie du doigt est preservee. */
    if (movedAboveFold && anchor && window.pageYOffset > 0) {
      var delta = anchor.getBoundingClientRect().top - anchorTop;
      if (Math.abs(delta) >= 1) window.scrollTo(0, window.pageYOffset + delta);
    }

    watch(sections);
    running = false;
  }

  /* Les marges posees ici ne changent pas la hauteur des sections :
     l'observateur ne peut donc pas s'auto-declencher en boucle. */
  function watch(sections) {
    if (typeof window.ResizeObserver !== 'function') return;
    if (!observer) {
      observer = new window.ResizeObserver(function () {
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(apply, 250);
      });
    }
    observer.disconnect();
    sections.forEach(function (section) { observer.observe(section); });
  }

  function schedule() {
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(apply);
    }
    window.setTimeout(apply, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  window.addEventListener('load', function () {
    schedule();
    window.setTimeout(apply, 700);
    window.setTimeout(apply, 2000);
  });

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastWidth) return;
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(apply, 200);
  });

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(apply, 80);
  });
})();
